import React from 'react';
import PropTypes from 'prop-types';
import { gaWrapper } from 'helpers/analytics';
import WithGeo from 'helpers/ads/WithGeo';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import ButtonPreferredSources from 'components_v2/common/ButtonPreferredSources';
import { getShortUrl } from 'utils/common';
import Links from 'components/Link';
import s from './SocialSharingNative.scss';
import CommentWidget from '../CommentWidget/CommentWidget';

function isUcBrowserUserAgent() {
  return (
    navigator.userAgent.toLowerCase().indexOf('ucb') >= 0 &&
    navigator.userAgent.toLowerCase().indexOf('android') >= 0
  );
}

class SocialSharingNative extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNativeShareVisible: false,
      isUcBrowser: false,
    };

    //this.onNativeShareClick = this.onNativeShareClick.bind(this);
  }

  componentDidMount() {
    let isNativeShareVisible = false;
    if (window.navigator.share) {
      isNativeShareVisible = true;
    }

    this.setState({
      isUcBrowser: isUcBrowserUserAgent(),
      isNativeShareVisible,
    });
  }

  //@bindGa({})
  onNativeShareClick = (
    e,
    gaCategory,
    gaAction,
    gaLabel,
    sticky,
    isLiveBlog,
    gaOnClick,
  ) => {
    if (typeof gaOnClick === 'function') {
      gaOnClick();
    }
    if (window.navigator.share) {
      gaWrapper('send', 'event', gaCategory, `${gaAction || 'more'}`, gaLabel);
      const { url, msid, platformTemplate } = this.props;
      let shareUrl = url;
      if (
        typeof url === 'string' &&
        url.trim() &&
        url.includes('utm_source=')
      ) {
        shareUrl = url;
      } else if (typeof url === 'string' && url.trim()) {
        const hasQuery = url.includes('?');
        const utmParams =
          'utm_source=mobilenative&utm_medium=mWeb_social&utm_campaign=social_share';
        shareUrl = `${url}${hasQuery ? '&' : '?'}${utmParams}`;
      }
      if (platformTemplate !== '') {
        analyticsWrapper('ga4', {
          event: 'share',
          method: 'mobile_native',
          entity_type: platformTemplate,
          ...(msid && msid !== undefined ? { item_id: msid } : {}),
        });
      }
      window.navigator.share({
        title: 'Timesofindia',
        url: getShortUrl(shareUrl, 'native_share_tray', true),
      });
    }
  };
  render() {
    const visibleNativeShareClass = this.state.isNativeShareVisible
      ? s.nshow
      : '';
    const {
      gaCategory,
      theme,
      gaAction,
      hidesharingdot,
      isEtimesArticle,
      sticky,
      isLiveBlog,
      gaOnClick,
    } = this.props;
    const gaLabel = this.props.gaLabel || 'native_share_tray';
    const isShareAvailable = !this.state.isUcBrowser;
    const googleNewsURL = isEtimesArticle
      ? 'https://news.google.com/publications/CAAqBwgKMKrsugswt4fSAw'
      : 'https://news.google.com/publications/CAAqBwgKMM6y_Qowwu70Ag';
    if (!isShareAvailable) {
      return null;
    }

    return (
      <React.Fragment>
        {isShareAvailable &&
          !hidesharingdot && (
            <div
              className={`${visibleNativeShareClass} ${s.icon_share} ${
                theme ? s[theme] : ''
              } ${this.props.nativeIconCss} ${this.props.nativeIconClassName}`}
              //data-ga={`${gaCategory}|more|${gaLabel}`}
              onClick={e =>
                this.onNativeShareClick(
                  e,
                  gaCategory,
                  gaAction,
                  gaLabel,
                  sticky,
                  isLiveBlog,
                  gaOnClick,
                )
              }
            >
              <i
                className={`${s.shareicon} ${
                  this.state.showSocialWidget ? s.active : ''
                }`}
              />
              {/* {typeof this.props.nativeIconClassName === 'undefined' ||
              this.props.nativeIconClassName === '' ? (
                <span>Share</span>
              ) : (
                ''
              )} */}
            </div>
          )}
        {!this.props.hideFollow && (
          <div className={`${s.gnews} ${s.gnews_top}`}>
            <Links
              href={googleNewsURL}
              target="_blank"
              rel="noopener noreferrer"
              data-newga="user_click#follow_google_news"
              ga4Data={
                sticky && [
                  {
                    event: 'user_click',
                    type: 'follow_google_news',
                    category: isLiveBlog
                      ? 'liveblog_sticky'
                      : 'articleshow_sticky',
                  },
                ]
              }
            >
              Follow us <i />
            </Links>
          </div>
        )}
        {this.props.showCommentWidget && (
          <CommentWidget
            msid={this.props.msid}
            isTablet={this.props.isTablet}
            isMobile
          />
        )}
        {this.props.showPreferredSources && (
          <WithGeo
            render={({ geoCountry }) =>
              geoCountry === 'US' || geoCountry === 'IN' ? (
                <div className={s.buttonPreferredSourcesWrapper}>
                  <ButtonPreferredSources
                    label={this.props.preferredSourcesLabel}
                    ariaLabel="Preferred Sources"
                  />
                </div>
              ) : null
            }
          />
        )}
      </React.Fragment>
    );
  }
}

SocialSharingNative.propTypes = {
  url: PropTypes.string.isRequired,
  gaCategory: PropTypes.string,
  theme: PropTypes.string,
  gaLabel: PropTypes.string,
  nativeIconCss: PropTypes.string,
  gaAction: PropTypes.string,
  hidesharingdot: PropTypes.bool,
  isEtimesArticle: PropTypes.bool,
  sticky: PropTypes.bool,
  isLiveBlog: PropTypes.bool,
  hideFollow: PropTypes.bool,
  showPreferredSources: PropTypes.bool,
  preferredSourcesLabel: PropTypes.string,
  gaOnClick: PropTypes.func,
};
SocialSharingNative.defaultProps = {
  gaCategory: 'share',
  theme: '',
  gaLabel: '',
  gaAction: '',
  nativeIconCss: '',
  hidesharingdot: false,
  isEtimesArticle: false,
  sticky: false,
  isLiveBlog: false,
  hideFollow: false,
  showPreferredSources: false,
  gaOnClick: () => {},
  preferredSourcesLabel: '',
};

export default SocialSharingNative;
